import React,{ Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import PaymentForm from '../../../shared/components/PaymentForm';

import {urlRoot} from '../../../shared/utils'

class AgencyCreatePaymentMethod extends Component {
  constructor(){
    super();

    this.state = {
      error:null
    };
  }

  handleSubmit(data) {
    const {
      match,
      history,
      activeAgency,
      createPaymentMethod,
      loadAgencyWithChildren,
      updateAgency
    } = this.props;
    return  createPaymentMethod({
        token: data.token,
        last4: data.last4,
        kind: data.kind,
        agencyId: activeAgency.id
      })
      .then(() => loadAgencyWithChildren(activeAgency.id))
      .then(res => new Promise(resolve => setTimeout(() => resolve(res), 1000)))
      .then((res) => {
        let cards = res.filter(c => c.collection === 'paymentMethods')[0]
          .instances
          .filter((p) => p.kind === 'card')
          .filter((p) => p.last4 === data.last4)
          .sort((a,b) => b.createdDate - a.createdDate)
        if (cards.length === 0 ) {
          return Promise.reject('Invalid card');
        }
        if (!cards[0].active){
          return Promise.reject(cards[0].message);
        }
        if (!activeAgency.defaultPaymentMethodId || !activeAgency.defaultPaymentMethodId.length > 0) {
          return updateAgency(activeAgency.id, {defaultPaymentMethodId: cards[0].id});
        }
        return Promise.resolve();
      })
      .then(() => history.push(`${urlRoot(match.url)}/account`))
  }

  render(){
    const { match, history } = this.props;

    return (
      <div className='AgencyCreatePaymentMethod'>
        <Container>
          <Row className='EntityList-title'>
            <Col xs='6'>
              <h1>New Payment Method</h1>
            </Col>
            <Col xs='6'></Col>
          </Row>
          <Row>
            <Col xs='8'>
              <PaymentForm
                createFormOnly
                onSubmit={(data) => this.handleSubmit(data)}
                allowCreateNewMethod
                showCancelButton
                onCancel={() => history.push(`${urlRoot(match.url)}/account`)}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

AgencyCreatePaymentMethod.propTypes = {
  //TODO: Fill in prop types for AgencyCreatePaymentMethod
};

AgencyCreatePaymentMethod.defaultProps = {
  //TODO: Fill in defaultProps for AgencyCreatePaymentMethod
};

export default AgencyCreatePaymentMethod;



// WEBPACK FOOTER //
// ./src/routes/AgencyCreatePaymentMethod/components/AgencyCreatePaymentMethod.js